import { useEffect } from "react"

const handlePageUnload = (e: BeforeUnloadEvent) => {
	e.preventDefault()
	e.returnValue = "Unsaved changes"
}

const useNavigationPreventionOnUnsavedChanges = (hasUnsavedChanges: boolean) => {
	useEffect(() => {
		if (hasUnsavedChanges) {
			addEventListener("beforeunload", () => handlePageUnload)
		}

		return () => {
			if (hasUnsavedChanges) {
				removeEventListener("beforeunload", handlePageUnload)
			}
		}
	}, [hasUnsavedChanges])
}

export default useNavigationPreventionOnUnsavedChanges
